import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { js_utils } from '../utils/frfr-js-utils';
import { useTableGenerator } from '../hooks/useTableGenerator';
import UniPaginationMuiTablePagination from './UniPaginationMuiTablePagination';
import { UniStickysmartHSpace, UniStickysmartStickyItem } from './UniStickysmartStickyItem';
import { useFrfrViewMultimode } from '../hooks/useFrfrViewMultimode';
import { react_utils } from '../utils/frfr-react-utils';


// UniViewMultimodeTableGenerator DOCUMENTATION is on the bootom of this file

/*
TODO:

- handlovanje s greskama
    dataError,
    blueprintError,



- row key extractor
i selectable arr
select single (radios)
select multiple (checkbox)

- PROBLEMATIKA kako da row component barata sa selectable
https://mui.com/x/react-data-grid/row-selection/?srsltid=AfmBOooFHPE8ahCzhY5BEp0_kEjWb-bY_j6oGSsUSJT2r7IJqERuRtR8#apiref
>getSelectedRows() Returns an array of the selected rows.
getSelectedRows: () => Map<GridRowId, GridRowModel>

isRowSelectable: (id: GridRowId) => boolean
isRowSelected: (id: GridRowId) => boolean
selectRow: (id: GridRowId, isSelected?: boolean, resetSelection?: boolean) => void
selectRows: (ids: GridRowId[], isSelected?: boolean, resetSelection?: boolean) => void




- baratnje sa CSV, CSV delimiter, CSV bez header row-a

- ??? JSDIsplayAOA ili Array of objects ???

*/


//
const ResizableTh = (props) => {
  const {
    /*
    width,
    minWidth = 80,
    maxWidth = 600,
    onResize,
    children,
    */
    children,
    // minWidth = 24,
    maxWidth = 600,
    // initialWidth,

    onResize,
    cl,
  } = props;
  let minWidth = 24;
  if (js_utils.is_number_zero_or_greater(props.minWidth)) {
    minWidth = props.minWidth;
  }
  let initialWidth = minWidth;
  if (js_utils.is_number_zero_or_greater(props.initialWidth)) {
    initialWidth = props.initialWidth;
  }
  /*
  const startXRef = useRef(0);
  const startWidthRef = useRef(width);
  const draggingRef = useRef(false);
  */
  const thRef = useRef(null);
  const startXRef = useRef(0);
  const startWidthRef = useRef(0);
  const [width, setWidth] = useState(initialWidth || 0);

  useEffect(() => {
    if (!width && thRef.current) {
      // setWidth(thRef.current.offsetWidth);
      const detectedInitialWidth = thRef.current.offsetWidth;
      let nextWidth = detectedInitialWidth;
      if (minWidth > nextWidth) {
        nextWidth = minWidth;
      }
      setWidth(nextWidth);
      if (typeof onResize === 'function') {
        onResize(nextWidth);
      }
    }
  }, [width]);

  /*
  const onMouseDown = (e) => {
    draggingRef.current = true;
    startXRef.current = e.clientX;
    startWidthRef.current = width;

    const onMouseMove = (moveEvent) => {
      if (!draggingRef.current) return;

      const delta = moveEvent.clientX - startXRef.current;
      const nextWidth = Math.min(
        maxWidth,
        Math.max(minWidth, startWidthRef.current + delta)
      );

      onResize(nextWidth);
    };

    const onMouseUp = () => {
      draggingRef.current = false;
      window.removeEventListener("mousemove", onMouseMove);
      window.removeEventListener("mouseup", onMouseUp);
    };

    window.addEventListener("mousemove", onMouseMove);
    window.addEventListener("mouseup", onMouseUp);
  };
  */

  const onMouseDown = (e) => {
    e.preventDefault();

    startXRef.current = e.clientX;
    startWidthRef.current = thRef.current.offsetWidth;

    const onMouseMove = (moveEvent) => {
      const delta = moveEvent.clientX - startXRef.current;
      const nextWidth = Math.min(
        maxWidth,
        Math.max(minWidth, startWidthRef.current + delta)
      );
      setWidth(nextWidth);
      if (typeof onResize === 'function') {
        onResize(nextWidth);
      }
    };

    const onMouseUp = () => {
      document.removeEventListener("mousemove", onMouseMove);
      document.removeEventListener("mouseup", onMouseUp);
    };

    document.addEventListener("mousemove", onMouseMove);
    document.addEventListener("mouseup", onMouseUp);
  };

  /*
  <th
    style={{
      width,
      position: "relative",
      padding: "8px 12px",
      border: "1px solid #ddd",
      userSelect: "none",
      whiteSpace: "nowrap",
    }}
  >
  */
  return (
    <th
      ref={thRef}
      className={cl + " frfr-table-generator__resizable-column"}
      style={{
        width: width || undefined,
        position: "relative",
        // userSelect: "none",
        // whiteSpace: "nowrap",
        // border: "1px solid #ddd",
        // padding: "8px 12px",
      }}
    >
      {children}
      <div
        onMouseDown={onMouseDown}
        className="frfr-table-generator__resizable-column__hoverable"
        style={{
          // position: "absolute",
          // top: 0,
          // right: 0,
          // width: "8px",
          // height: "100%",
          cursor: "col-resize",
          touchAction: "none",
          // outline: "1px dashed green",
          // backgroundColor: "yellow"
        }}
      ><div className="frfr-table-generator__resizable-column__hoverable-icon" /></div>
    </th>
  );
};


// DEFAULT COMPONENT
const UniViewMultimodeTableGenerator = (props) => {
  console.log('DEBUG props.rowsData', props.rowsData);
  const {
    // data
    fetching,
    dataError,
    rowsFinalReadyArr, // TODO
    isZeroItemsFinalReadyArr,
    tableRowsArr, // TODO

    // filtering
    _handleChangeColumnFilterString,

    // sorting
    _getColumnSortedState,
    _handleClick_table_th_sort,

    // pagination
    paginationPack,

    // selection
    selectedAllRowsChecked,
    selectedRowsCount,
    _isRowSelected,
    _handleClickSelectRow,
    _handleClickSelectAllRows,
    _handleClickSelectReset,

    // utils
    blueprintError,
    blueprintGeneral,
    blueprintTable,
    blueprintColumns,
    blueprintColumns_lookup_obj,
    blueprintRow,
    _cellValueExtractor, // NOVO 
    // TableGenerator
    _isColumnRenderingEnabled,
    _handleClickShowMoreColumns,
    _is_column_index_first_in_special_more_section,
  } = useFrfrViewMultimode(props.fetching, props.viewMultimodeBlueprint, props.rowsData, props.rowsDataFreshness, props.cbOnSelectionChange, props.cbOnSelectionChangeSingular);
  console.log('DEBUG rowsFinalReadyArr', rowsFinalReadyArr);

  if (typeof blueprintError === 'string') { // CASE ERROR viewMultimodeBlueprint
    console.log('UniViewMultimodeTableGenerator ERROR - ', blueprintError);
    return (
      <>
        <div className="jsunicompo-display-velue-error-msg"><span>{blueprintError}</span></div>
      </>
    );
  }


  // ----- fetching and spinner
  let is_footer = false;
  let is_pagination = true;
  let jsxSpinner = null;
  let jsxSpinner2 = null;
  let jsxZero = null;
  let jsxMsgSelected = null;
  if (fetching === true) {
    // jsxSpinner
    is_footer = true;
    if (props.jsxSpinnerCustom) {
      jsxSpinner = props.jsxSpinnerCustom;
    } else {
      jsxSpinner = <div className="frfr-table-generator__msg-please-wait">Please wait...</div>
    }
    jsxSpinner2 = (
      <div className="frfr-table-generator__spinner">{jsxSpinner}</div>
    );
  } else {
    if (rowsFinalReadyArr.length === 0) {
      is_footer = true;
      jsxZero = (
        <div className="frfr-table-generator__zero-items">No items to show</div>
      );
    }
    if (selectedRowsCount > 0) {
      is_footer = true;
      jsxMsgSelected = (
        <div className="frfr-table-generator__zero-items">{selectedRowsCount} rows selected</div>
      );
    }
  }
  if (is_pagination) {
    is_footer = true;
  }

  let is_table_resizable = false;
  let resizableColumnMinWidth = 32;
  if (blueprintTable.resizableColumnMinWidth && blueprintTable.resizableColumnMinWidth > resizableColumnMinWidth) {
    resizableColumnMinWidth = blueprintTable.resizableColumnMinWidth;
  }

  // ----- CSS extra classes
  //
  let cl_props_widget = '';
  if (props.widgetExtraClass && typeof props.widgetExtraClass === 'string') {
    cl_props_widget += ' ' + props.widgetExtraClass;
  }
  //
  let cl_props_container = '';
  if (props.tableContainerExtraClass && typeof props.tableContainerExtraClass === 'string') {
    cl_props_container += ' ' + props.tableContainerExtraClass;
  }
  //
  let cl_props_table = '';
  if (props.tableExtraClass && typeof props.tableExtraClass === 'string') {
    // dodatno ako je na <TableGenerqator> takodje stavljen prop tableExtraClass i njega stavljamo na kraju na table
    cl_props_table += ' ' + props.tableExtraClass;
  }
  //
  let cl_blu_widget = '';
  if (blueprintGeneral.responsiveTable === true) {
    cl_blu_widget += ' frfr-table-generator__pack--responsive-table';
  }
  if (typeof blueprintGeneral.widgetExtraClass === 'string') {
    cl_blu_widget += ' ' + blueprintGeneral.widgetExtraClass;
  }
  //
  let cl_blu_container = '';
  if (typeof blueprintGeneral.tableContainerExtraClass === 'string') {
    cl_blu_container += ' ' + blueprintGeneral.tableContainerExtraClass;
  }
  //
  let cl_blu_table = '';
  if (blueprintTable.showFilterRow === true) {
    cl_blu_table += ' frfr-table-generator__table--show-filter-row';
  }
  if (blueprintTable.resizable === true) {
    is_table_resizable = true;
    cl_blu_table += ' frfr-table-generator__table--resizable unirole-table-resizable';
  }
  if (typeof blueprintTable.extraClass === 'string') {
    cl_blu_table += ' ' + blueprintTable.extraClass;
  }

  // ----------- render data phase

  // ----- render table THEAD regular row
  let jsxTableHeaderRowCells = [];
  if (true) {
    if (blueprintTable.showSelectable === true) {
      jsxTableHeaderRowCells.push(
        <th key={"special-selectable-multiple"} className={"special-selectable-multiple"} onClick={() => { }}>

          <div className={""} style={{}}>
            {
              blueprintTable.showSelectAll === true && (
                <label className="uniformcompo__label-wrapping-checkbox" htmlFor={'select_table_row_' + '001'}>
                  <span className="uu-anyinput__control-container uniformcompo__checkbox-aura">
                    <input
                      type="checkbox"
                      name={'select_table_row_' + '001'}
                      readOnly={false}
                      disabled={false}
                      checked={selectedAllRowsChecked === true}
                      onChange={() => { _handleClickSelectAllRows(); }}
                    />
                  </span>
                </label>
              )
            }
          </div>

        </th>
      );
    }
    if (blueprintTable.showSelectableSingular === true) {
      jsxTableHeaderRowCells.push(
        <th key={"special-selectable-singular"} className={"special-selectable-singular"} onClick={() => { }}>

          <div className={""} style={{}}>
            <label className="uniformcompo__label-wrapping-checkbox" htmlFor={'select_table_row_' + '002'}>
              <span className="label"></span>
              <span className="uu-anyinput__control-container uniformcompo__checkbox-aura">
                <input
                  type="radio"
                  name={'select_table_row_' + '002'}
                  value={''}
                  checked={false}
                  onChange={() => { _handleClickSelectAllRows(true); }}
                />
              </span>
            </label>
          </div>

        </th>
      );
    }
    // blueprintColumns.forEach((_cellBlu, col_index) => {
    blueprintColumns.forEach((cellBlu, col_index) => { // already fixed cellBlu
      // const cellBlu = fixCellBlueprint(_cellBlu);
      // const cellBlu = _cellBlu; // already fixed cellBlu
      const k = cellBlu.key;
      // console.log('key', k, 'cellBlu', cellBlu);

      //
      if (_isColumnRenderingEnabled(col_index)) {
        const _column_sorted_state = _getColumnSortedState(k, cellBlu);
        let cl = 'frfr-table-generator__thead__th uu-anytable__cell--pad-0 ';
        if (typeof cellBlu.extraClassTh === 'string') { // CASE extraClass is string
          cl += cellBlu.extraClassTh + ' ';
        } else if (typeof cellBlu.extraClassTh === 'function') { // CASE extraClass BY CALLBACK
          cl += ' ' + cellBlu.extraClassTh(); // extraClassTh ne prima row kao argument
        }
        let _content = null;
        if (cellBlu.thCb && typeof cellBlu.thCb === 'function') {
          _content = cellBlu.thCb(col_index); // thCb ne prima row kao argument
        } else {
          _content = cellBlu.title;
          /*
          if (Array.isArray(_content)) {
            _content = (<i>*ARRAY</i>);
          } else {
            if (js_utils.is_object(_content)) {
              _content = (<i>*OBJECT</i>);
            }
          }
          */
        }
        // console.log('_content', _content);
        let jsxSortedSymbol = null;
        let th_cell_style = {};
        let minCellWidth = 32;
        if (is_table_resizable === true) {
          if (resizableColumnMinWidth > minCellWidth) {
            minCellWidth = resizableColumnMinWidth;
          }
          if (cellBlu.minWidth > minCellWidth) {
            minCellWidth = cellBlu.minWidth;
          }
          th_cell_style.width = minCellWidth;
          th_cell_style.minWidth = minCellWidth;
        }
        if (_column_sorted_state.sortable === true) {
          cl += ' frfr-table-generator__sortable-column clickable';
          jsxSortedSymbol = (
            <div className="unicompo-sortable-icon__aura-clickable unicompo-sortable-icon__aura-clickable--inactive"><i className="fa fa-sort" aria-hidden="true"></i></div>
          );
          let cl_sortable_icon = "unicompo-sortable-icon__aura-clickable unicompo-sortable-icon__aura-clickable--inactive";
          if (_column_sorted_state.sorted === true) {
            cl_sortable_icon = "unicompo-sortable-icon__aura-clickable";
            cl_sortable_icon += " unicompo-sortable-icon__aura-clickable--sorted";
            cl += ' frfr-table-generator__sortable-column--sorted';
          }
          let _fa = "fa fa-sort";
          if (_column_sorted_state.asc === true) {
            _fa = "fa fa-caret-up";
            // cl += ' sorted';
            /*
            jsxSortedSymbol = (
              <div className="unicompo-sortable-icon__aura-clickable"><i className="fa fa-caret-up" aria-hidden="true"></i></div>
              );
              */
          } else if (_column_sorted_state.asc === false) {
            _fa = "fa fa-caret-down";
            // cl += ' sorted';
            /*
            jsxSortedSymbol = (
              <div className="unicompo-sortable-icon__aura-clickable"><i className="fa fa-caret-down" aria-hidden="true"></i></div>
            );
            */
          }
          jsxSortedSymbol = (
            <div className={cl_sortable_icon}><i className={_fa} aria-hidden="true"></i></div>
          );
          //
          if (is_table_resizable === true && cellBlu.resizable === true) {
            jsxTableHeaderRowCells.push(
              <ResizableTh
                key={k}
                cl={cl}
                onResize={() => { }}
                minWidth={minCellWidth}
                initialWidth={cellBlu.w}
              >
                <div className="uu-anytable__cell__inner uu-anytable__cell__inner--pad" onClick={() => { _handleClick_table_th_sort(k) }}><span className="uu-text-nowrap">{_content}{jsxSortedSymbol}</span></div>
              </ResizableTh>
            );
          } else {
            jsxTableHeaderRowCells.push(
              <th key={k} className={cl} style={th_cell_style}>
                <div className="uu-anytable__cell__inner uu-anytable__cell__inner--pad" onClick={() => { _handleClick_table_th_sort(k) }}><span className="uu-text-nowrap">{_content}{jsxSortedSymbol}</span></div>
              </th>
            );
          }
        } else {
          // CASE not sortable
          /*
          jsxTableHeaderRowCells.push(
            <th key={k} className="nesto1"><span>{_content}</span></th>
          );
          */
          let cl = 'frfr-table-generator__thead__th uu-anytable__cell--pad-0 ';
          if (cellBlu.resizable === true) {
            let minCellWidth = 32;
            if (resizableColumnMinWidth > minCellWidth) {
              minCellWidth = resizableColumnMinWidth;
            }
            if (cellBlu.minWidth > minCellWidth) {
              minCellWidth = cellBlu.minWidth;
            }
            jsxTableHeaderRowCells.push(
              <ResizableTh
                key={k}
                cl={cl}
                onResize={() => { }}
                minWidth={minCellWidth}
                initialWidth={cellBlu.w}
              >
                <div className="uu-anytable__cell__inner uu-anytable__cell__inner--pad"><span>{_content}</span></div>
              </ResizableTh>
            );
          } else {
            jsxTableHeaderRowCells.push(
              <th key={k} className={cl} style={th_cell_style}>
                <div className="uu-anytable__cell__inner uu-anytable__cell__inner--pad"><span>{_content}</span></div>
              </th>
            );
          }
        }
      } else if (_is_column_index_first_in_special_more_section(col_index)) {
        jsxTableHeaderRowCells.push(
          <th key={"frfr-table-generator__cell__special-more-collapsed"} className={"frfr-table-generator__cell__special-more-collapsed"} onClick={_handleClickShowMoreColumns}>&gt;&gt;&nbsp;Više...</th>
        );
      } else {
        // ignored cells
      }
    }); // end of forEach
  }


  // ----- render table THEAD special filter row
  let jsxTableHeaderFilterRow = null;
  let jsxTableHeaderFilterRowCells = [];
  if (blueprintTable.showFilterRow === true) {
    if (blueprintTable.showSelectable === true) {
      jsxTableHeaderFilterRowCells.push(<th key={"special-selectable-multiple"}></th>);
    }
    if (blueprintTable.showSelectableSingular === true) {
      jsxTableHeaderFilterRowCells.push(<th key={"special-selectable-singular"}></th>);
    }
    blueprintColumns.forEach((cellBlu, col_index) => { // already fixed cellBlu
      const k = cellBlu.key;
      if (_isColumnRenderingEnabled(col_index)) {
        if (cellBlu.filterable === true) {
          jsxTableHeaderFilterRowCells.push(
            <th key={k} className={"frfr-table-generator__thead__th uu-anytable__cell--pad-0  frfr-table-generator__filterable-column"}>
              <div className="uu-anytable__cell__inner uu-anytable__cell__inner--fill-absolute">
                <div className="unitablecompo__filter-cell__field-pack">
                  <div className="unitablecompo__filter-cell__field-pack__icon-left">
                    <i className="fa fa-search" aria-hidden="true"></i>
                  </div>
                  <input
                    type="text"
                    onChange={(e) => {
                      const q = e.target.value;
                      _handleChangeColumnFilterString(k, q);
                    }}
                    className="unitablecompo__filter-cell__field-pack__input unitablecompo__filter-cell__field-pack__input--integrated-in-cell"
                  />
                </div>
              </div>
            </th>
          );
        } else {
          jsxTableHeaderFilterRowCells.push(<th key={k}></th>);
        }
      } else if (_is_column_index_first_in_special_more_section(col_index)) {
        jsxTableHeaderFilterRowCells.push(
          <th key={"frfr-table-generator__cell__special-more-collapsed"} className={"frfr-table-generator__cell__special-more-collapsed"} onClick={_handleClickShowMoreColumns}>&gt;&gt;&nbsp;Više...</th>
        );
      } else {
        // ignored cells
      }
    }); // end of forEach
    jsxTableHeaderFilterRow = (
      <tr className="frfr-table-generator__tr-special-filter-row">
        {jsxTableHeaderFilterRowCells}
      </tr>
    );
  }


  // ----- render table TBODY rows
  let jsxTableRows = [];
  if (props.fetching === true) { // CASE jsxSpinner
    // spinner
  } else { // CASE rows
    // rowsFinalReadyArr = sortedData;
    if (blueprintRow.mapCb && typeof blueprintRow.mapCb === 'function') { // CB blueprintRow
      // CASE row will be displayed by callback
      // jsxTableRows.push(blueprintRow.mapCb(row, row_index));
      jsxTableRows = rowsFinalReadyArr.map(blueprintRow.mapCb);
    } else { // CASE using blueprintColumns
      rowsFinalReadyArr.forEach((row, row_index) => {
        // const row_key = row_index; // TODO
        let row_key; // TODO
        // console.log('blueprintRow', blueprintRow);
        if (typeof blueprintRow.rowKeyExtractor === 'function') {
          row_key = blueprintRow.rowKeyExtractor(row, row_index); // TODO
        }
        // let jsxtableRowSingle = Object.keys(row).map((item, col_index) => {
        let jsxtableRowSingle = [];
        if (blueprintTable.showSelectable === true) {
          jsxtableRowSingle.push(
            <td key={"special-selectable-multiple"} className={"special-selectable-multiple"} onClick={() => { /* click on row is different form input change */ }}>

              <div className={''} style={{}}>
                <label className="uniformcompo__label-wrapping-checkbox" htmlFor={'select_table_row_' + row_key}>
                  <span className="uu-anyinput__control-container uniformcompo__checkbox-aura">
                    <input
                      type="checkbox"
                      name={'select_table_row_' + row_key}
                      readOnly={false}
                      disabled={false}
                      checked={_isRowSelected(row_key)}
                      onChange={() => { _handleClickSelectRow(row_key); }}
                    />
                  </span>
                </label>
              </div>

            </td>
          );
        }
        if (blueprintTable.showSelectableSingular === true) {
          jsxtableRowSingle.push(
            <td key={"special-selectable-singular"} className={"special-selectable-singular"} onClick={() => { }}>

              <div className={""} style={{}}>
                <label className="uniformcompo__label-wrapping-checkbox">
                  <span className="label"></span>
                  <span className="uu-anyinput__control-container uniformcompo__checkbox-aura">
                    <input
                      type="radio"
                      name={'select_table_row_' + '000'}
                      value={''}
                      checked={_isRowSelected(row_key, true)}
                      onChange={() => { _handleClickSelectRow(row_key, true); }}
                    />
                  </span>
                </label>
              </div>

            </td>
          );
        }
        blueprintColumns.forEach((cellBlu, col_index) => { // already fixed cellBlu
          // const cellBlu = fixCellBlueprint(_cellBlu);
          // const cellBlu = _cellBlu; // already fixed cellBlu
          const k = cellBlu.key;
          // console.log('key', k, 'cellBlu', cellBlu);
          let cl = ''; // td css class
          let td_title_attr = null; // td cell title attribute
          let _content = null; // td content - default null React will not render anything in cell
          let _pure_val; // pure unformatted value of cell
          if (_isColumnRenderingEnabled(col_index)) {
            let cl_external = '';
            if (cellBlu.tdCb && typeof cellBlu.tdCb === 'function') { // CASE cell content rendered by callback for display formatted value
              const rendered_by_cb = cellBlu.tdCb(row, k, col_index, row_index);
              if (Array.isArray(rendered_by_cb)) {
                _content = rendered_by_cb[0];
                if (typeof rendered_by_cb[1] === 'string') {
                  cl_external = rendered_by_cb[1];
                }
              } else {
                _content = rendered_by_cb;
              }
              if (is_table_resizable === true) {
                if (cellBlu.cellValueExtractor && typeof cellBlu.cellValueExtractor === 'function') { // CASE cell content rendered by callback
                  _pure_val = cellBlu.cellValueExtractor(row, k, col_index, row_index); // extract pure value
                } else { // CASE cell content rendered regular
                  _pure_val = row[k]; // TODO when cell content is primitive renderable value
                }
              }
            } else { //
              if (cellBlu.cellValueExtractor && typeof cellBlu.cellValueExtractor === 'function') { // CASE cell content rendered by callback
                _pure_val = cellBlu.cellValueExtractor(row, k, col_index, row_index); // extract pure value
                _content = _pure_val;
              } else { // CASE cell content rendered regular
                _pure_val = row[k]; // TODO when cell content is primitive renderable value
                _content = _pure_val;
              }
            }
            if (react_utils.is_renderable(_content)) {
            } else { // CASE not renderable ERROR message
              /*
              if (Array.isArray(_content)) { // TODO
                _content = (<i>*ARRAY</i>);
              } else if (js_utils.is_object(_content)) { // TODO
                _content = (<i>*OBJECT</i>);
              }
              */
              _content = (
                <div className="jsunicompo-display-velue-error-msg"><span>ERROR: Invalid content!</span></div>
              );
            }
            if (is_table_resizable === true) {
              td_title_attr = _pure_val;
            }
            if (cellBlu.number === true) {
              cl = 'frfr-table-generator__td-number ';
            }
            if (typeof cellBlu.extraClass === 'string') {
              cl += ' ' + cellBlu.extraClass;
            }
            if (typeof cellBlu.extraClass === 'function') {
              // CASE CALLBACK
              cl += ' ' + cellBlu.extraClass(row);
            }
            jsxtableRowSingle.push(
              <td key={k} className={cl} title={react_utils.fix_attr(td_title_attr)}>{_content}</td>
            );
          } else if (_is_column_index_first_in_special_more_section(col_index)) { // CASE special cell in the beggining of the collapsed columns 
            jsxtableRowSingle.push(
              <td key={"frfr-table-generator__cell__special-more-collapsed"} className={"frfr-table-generator__cell__special-more-collapsed"} onClick={_handleClickShowMoreColumns}>&gt;&gt;&nbsp;Više...</td>
            );
          } else {
            // ignored cells
          }
        }); // end of forEach cellBlu
        //
        let cl_tr = '';
        if (typeof blueprintRow.extraClass === 'string') {
          cl_tr = blueprintRow.extraClass;
        }
        if (typeof blueprintRow.extraClass === 'function') {
          // CASE CALLBACK
          cl_tr += ' ' + blueprintRow.extraClass(row);
        }
        jsxTableRows.push(
          <tr key={row_key} className={cl_tr}>
            {jsxtableRowSingle}
          </tr>
        );
      }); // end of forEach row
    }
  }

  console.log('rowsFinalReadyArr', rowsFinalReadyArr);
  console.log('rowsFinalReadyArr.length', rowsFinalReadyArr.length);
  // render table
  return (
    <div className={"frfr-table-generator__pack " + cl_blu_widget + cl_props_widget}>
      <div className={"frfr-table-generator__table-container" + cl_blu_container + cl_props_container}>
        <table className={"thisis-table-generated-by-TableGenerator frfr-table-generator__table " + cl_blu_table + cl_props_table}>
          <thead>
            <tr className="frfr-table-generator__thead__tr-primary-row">
              {jsxTableHeaderRowCells}
            </tr>
            {jsxTableHeaderFilterRow}
          </thead>
          <tbody>
            {jsxTableRows}
          </tbody>
        </table>
      </div>
      <div className="frfr-table-generator__bellow-table">
        {
          props.fetching === true ? (
            <div className="frfr-table-generator__spinner">{jsxSpinner}</div>
          ) : (
            <>
              {
                rowsFinalReadyArr.length === 0 ? (
                  <div className="frfr-table-generator__zero-items">No items to show</div>
                ) : (null)
              }
              {
                selectedRowsCount > 0 ? (
                  <div className="frfr-table-generator__zero-items">{selectedRowsCount} rows selected</div>
                ) : (null)
              }
            </>
          )
        }
      </div>

      {
        is_footer === true && (
          <div className="frfr-table-generator__footer MuiDataGrid-footerContainer MuiDataGrid-withBorderColor css-5n0k77">
            <div className="frfr-table-generator__msg-container MuiDataGrid-selectedRowCount css-1898wwh">
              {jsxSpinner2}
              {jsxZero}
              {jsxMsgSelected}
            </div>

            <div className="frfr-table-generator__pagination-container">
              <UniPaginationMuiTablePagination paginationPack={paginationPack} />
            </div>

            {/*
            <div>
              <UniStickysmartHSpace>
                <UniStickysmartStickyItem left right>
                  <UniPaginationMuiTablePagination paginationPack={paginationPack} />
                </UniStickysmartStickyItem>
              </UniStickysmartHSpace>
            </div>
            */}

          </div>
        )
      }


    </div>
  );
};
/*
<siv>PRAZNO {rowsFinalReadyArr.langth}</siv>
          rowsFinalReadyArr.length === 0 ? (
            <div className="frfr-table-generator__zero-items">No items to show</div>
          ) : (null)

<p className="MuiTablePagination-displayedRows css-wqp0ve">1–5 of 9</p>

*/

UniViewMultimodeTableGenerator.propTypes = {
  // blueprintColumns: PropTypes.array,
  rowsData: PropTypes.array
};

export default UniViewMultimodeTableGenerator;

/*
// ---------- TableGenerator DOCUMENTATION ---------

----- TableGenerator React props:

fetching={true} // true means data is not ready, ffetching/loading

jsxSpinnerCustom={<Spinner />} // custom spiiner to display when fetching

rowsData={[]}

tableBlueprint={{
  freshness: null,
  general: {
    widgetExtraClass: '',
  },
  table: {
    extraClass: '',
    numberOfColumnsBeforeMore: 1,
  },
  defaultColumnBlueprint: {},
  columns: [],
  row: {
    extraClass: '',
    mapCb: (item, row_index)=>{} // if function rows will ba mapped by this mapCb map callbackFn
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/map
  },
}}

widgetExtraClass={''}

tableContainerExtraClass={'uu-text-nowrap'}

tableExtraClass={'uu-anytable--zebra-rows'} // use only if you have no access to blueprint

cbOnSelectionChange={()=>{}} // call parent component on every selection change

cbOnSelectionChangeSingular={()=>{}} // call parent component on every singularMode selection change


---------- tableBlueprint INSPIRATION ----------

----- tableBlueprint.columns
Array of cellBlueprint

----- tableBlueprint.defaultColumnBlueprint

*/

/*
// example data
let data = [
  {
    kolona1: '100',
    b: '200',
    c: '33'
  },
  {
    kolona1: '102',
    b: '300',
    c: '22'
  },
  {
    kolona1: '103',
    b: '100',
    c: '11'
  }
];

// example definicija
let blueprintColumns = [
  {
    key: 'kolona1',
    title: 'Kolona 1'
  },
  {
    key: 'b',
    title: 'Kolona B',
    sortable: true
  },
  {
    key: 'c',
    title: 'Kolona C',
    sortable: true
  }
];
*/

/*
INSPIRATION

https://mui.com/material-ui/react-table/?srsltid=AfmBOoqFhMZj7UNCNwRBPoKiwmIyFG3v-SGPnn8VHZLsJ3iZLwQukncU#data-table
Data table

// columns blueprint
const columns: GridColDef[] = [
  { field: 'id', headerName: 'ID', width: 70 },
  { field: 'firstName', headerName: 'First name', width: 130 },
  { field: 'lastName', headerName: 'Last name', width: 130 },
  {
    field: 'age',
    headerName: 'Age',
    type: 'number',
    width: 90,
  },
  {
    field: 'fullName',
    headerName: 'Full name',
    description: 'This column has a value getter and is not sortable.',
    sortable: false,
    width: 160,
    valueGetter: (value, row) => `${row.firstName || ''} ${row.lastName || ''}`,
  },
];

// rows data
const rows = [
  { id: 1, lastName: 'Snow', firstName: 'Jon', age: 35 },
  { id: 2, lastName: 'Lannister', firstName: 'Cersei', age: 42 },
  { id: 3, lastName: 'Lannister', firstName: 'Jaime', age: 45 },
  { id: 4, lastName: 'Stark', firstName: 'Arya', age: 16 },
  { id: 5, lastName: 'Targaryen', firstName: 'Daenerys', age: null },
  { id: 6, lastName: 'Melisandre', firstName: null, age: 150 },
  { id: 7, lastName: 'Clifford', firstName: 'Ferrara', age: 44 },
  { id: 8, lastName: 'Frances', firstName: 'Rossini', age: 36 },
  { id: 9, lastName: 'Roxie', firstName: 'Harvey', age: 65 },
];


Data Grid - Filtering
https://mui.com/x/react-data-grid/filtering/?srsltid=AfmBOoqR5oKP0YA4Rqv3ySmcaIrQDot6MjLfdh7IsS7v7a_3WxU2_yEC


// devexpress
React Data Grid - Filter Panel
https://js.devexpress.com/React/Demos/WidgetsGallery/Demo/DataGrid/FilterPanel/MaterialBlueLight/

React Data Grid - Column Header Filter
https://js.devexpress.com/React/Demos/WidgetsGallery/Demo/DataGrid/ColumnHeaderFilter/MaterialBlueLight/


*/

